<template>
  <div id="totalBox">
    <div class="content">
      <p class="productCenterTitle">产品中心</p>
      <div class="productListBox">
        <router-link to='/CModel' active-class="active" active class="productList">用户端（C端）</router-link>
        <router-link to='/BModel' active-class="active" class="productList">管理端（B端）</router-link>
        <router-link to='/Parksoftware' active-class="active" class="productList">智能识别系统</router-link>
        <router-link to='/Other' active-class="active" class="productList">其他产品</router-link>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'productModel',
  data: function () {
    return {
      msg: '0'
    }
  }
}
</script>

<style scoped>
#totalBox{
  width: 100%;
  background-color: #fff;
}
.content{
  margin: 0 auto;
  padding-top: 55px;
}
.productCenterTitle{
  font-size:40px;
  font-weight:bold;
  color:rgba(35,24,21,1);
  width: 1200px;
  margin: 0 auto;
}
.productListBox{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1200px;
  margin: 0 auto;
}
.productList{
  font-size:24px;
  font-weight:400;
  color:rgba(117,117,117,1);
  line-height:39px;
  text-decoration: none;
  width: 300px;
  margin-top: 56px;
  border-bottom: 2px solid rgba(247,247,247,1);
  padding-bottom: 9px;
}
.active{
  border-bottom: 2px solid rgba(255,182,30,1);
  color:rgba(35,24,21,1);
}
</style>



// WEBPACK FOOTER //
// src/components/productCenter/productModel.vue